import { defaultsSettingApi } from "api/TenantSlug/Setting/api.ts";
import { AxiosError } from "axios";

export async function tenantExists(tenantSlug: string): Promise<boolean> {
    try {
        await defaultsSettingApi.defaults(tenantSlug, true);
        return true;
    } catch (error) {
        if ((error as AxiosError)?.response?.status === 404) {
            return false;
        }
        throw error;
    }
}
